const Color = {
  DEFAULT_BG: "#172554",
};

export default Color